import React, { useEffect, useState } from 'react';
import '../../style/css/homepage2026.css';
import Notifhp from './Notifhp';
import H2Homepage from './H2homepage';
import iconnotif from '../../style/icons/notification.svg';
import { listNotifications } from '../../services/notifications';

// Home-page notifications section — real, server-backed (notificationsList act). Shows the
// business's latest booking alerts (new/manual/cancel/no-show/reminder). The navbar bell is
// the primary surface + mark-as-read; this section is a passive read-only view.
const NotifhpContainer = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        (async () => {
            const { items: rows } = await listNotifications();
            if (alive) { setItems(rows); setLoading(false); }
        })();
        return () => { alive = false; };
    }, []);

    return (
        <section className="hp-section">
            <H2Homepage title="התראות" iconName={iconnotif} />
            {loading ? (
                <div className="hp-empty">טוען…</div>
            ) : items.length ? (
                <div className="hp-notifs">{items.map((n) => <Notifhp key={n.ID} {...n} />)}</div>
            ) : (
                <div className="hp-empty">אין התראות חדשות</div>
            )}
        </section>
    );
};

export default NotifhpContainer;
